import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 20l14 -8l-14 -8l0 16","key":"svg-0"}],["path",{"d":"M19 20l-14 -8l14 -8l0 16","key":"svg-1"}]]

/**
 * IconBrandBackbone
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtYmFja2JvbmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgMjBsMTQgLThsLTE0IC04bDAgMTYiIC8+CiAgPHBhdGggZD0iTTE5IDIwbC0xNCAtOGwxNCAtOGwwIDE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-backbone
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandBackbone = createReactComponent('outline', 'brand-backbone', 'BrandBackbone', __iconNode);

export default IconBrandBackbone;